import store from "@/store"

export default {
    get atHome() {
        return this.experienceType === "at_home"
    },

    get inStore() {
        return this.experienceType === "in_store"
    },

    get experienceType() {
        return this.session?.experienceType
    },

    get flowType() {
        return this.session?.flowType
    },

    get providerKey() {
        return store.state.session.data?.dynamicProviderKey?.toString()
    },

    get dynamicProviderKey() {
        return store.state.session.data?.dynamicProviderKey
    },

    set dynamicProviderKey(dynamicProviderKey) {
        store.commit("session/updateDynamicProviderKey", dynamicProviderKey)
    },

    get nextProviderKeyAfterExistingAccount() {
        return store.state.session.data?.nextProviderKeyAfterExistingAccount
    },

    set nextProviderKeyAfterExistingAccount(nextProviderKeyAfterExistingAccount) {
        store.commit("session/updateNextProviderKeyAfterExistingAccount", nextProviderKeyAfterExistingAccount)
    },

    get session() {
        return store.state.session.data
    },

    set session(session) {
        store.commit("session/update", session)
    },

    get previousSession() {
        return store.state.session.previous
    },

    set previousSession(session) {
        store.commit("session/updatePrevious", session)
    },

    get environment() {
        return store.state.session.data.env
    },

    set environment(env) {
        store.commit("session/updateEnv", env)
    },

    getProperty(name) {
        if (!this.session?.properties) return null
        return this.session.properties[name]
    },

    openCancelModal() {
        store.commit("session/showCancelModal", true)
    },

    closeCancelModal() {
        store.commit("session/showCancelModal", false)
    },

    getExtensionsProperties(featureId) {
        return this.session?.extensions?.find(ext => ext.featureId === featureId)?.properties || null
    },
}
